import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ItsmService } from '../../services/itsm.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-upload-files',
  templateUrl: './upload-files.component.html',
  styleUrls: ['./upload-files.component.scss']
})
export class UploadFilesComponent implements OnInit {

  @Input()
  caseRef: string;

  @Output()
  flagEmitter = new EventEmitter<any>();

  selectedFiles: FileList;
  progressInfos = [];
  message = '';
  MAX_FILESIZE = 1024 * 1024 * 100; // 100meg

  fileInfos: Observable<any>;

  constructor(private itsmService : ItsmService) { }

  ngOnInit(): void {
  }

  selectFiles(event): void {
    this.progressInfos = [];
    this.selectedFiles = event.target.files;
  }

  upload(idx, file): void {
    this.progressInfos[idx] = { value: 0, fileName: file.name };
    this.itsmService.upload(file, this.caseRef).then(
      event => {
        
          this.selectedFiles = null ;
          this.progressInfos[idx].value = 100;   
          this.flagEmitter.emit(this.message);     
          this.progressInfos = []; 

      }).catch( err => {
        this.progressInfos[idx].value = 0;
        this.flagEmitter.emit("Error: File failed to upload, please try again");    
        this.message = 'Could not upload the file:' + file.name;
      })
  }

  uploadFiles(): void {
    this.message = '';
    for (let i = 0; i < this.selectedFiles.length; i++) {

      if(this.selectedFiles[i].size > this.MAX_FILESIZE || !environment.allowedFileTypes.includes(this.selectedFiles[i].type)){

        this.message = "File upload failed! The file must be < 16Mb and one of the following formats doc, docx, xls, xlsx, ppt, pptx, txt, csv, png, jpg, gif or pdf";    
        this.flagEmitter.emit(this.message);    
      }else{
        this.upload(i, this.selectedFiles[i]);
        this.message = "Successful"; 
      }
    }
  }

}
